import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import loadScripts from '../../../dassets/js/custom';
class DirectorData1 extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
        this.onChangeSignature = this.onChangeSignature.bind(this);
        this.data = {
            signature: null,
        }
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            title: this.refs.title.value,
            gender: this.refs.gender.value,
            surname: this.refs.surname.value,
            first_name: this.refs.first_name.value,
            other_name: this.refs.other_name.value,
            email: this.refs.email.value,
            dob: this.refs.dob.value,
            res_add: this.refs.res_add.value,
            id_means: this.refs.id_means.value,
            phone: this.refs.phone.value,
            bvn: this.refs.bvn.value,
            signature: this.data.signature,
            signature_path: `cform_signature_${this.refs.surname.value}_${this.refs.first_name.value}_${new Date().getTime()}.png`
        }

        this.props.saveValues(data, 'director_data')
        this.props.nextStep()
    }

    onChangeSignature(e) {
        const fileTypes = ['image/png', 'image/gif', 'image/jpeg'];

        let file = e.target.files[0];
        if (fileTypes.every(extension => file.type !== extension)) {
            toast.error(`The file ${file.type} extension is not supported`);
            return
        }
        this.data.signature = file;
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Director's Data (Director 1)</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Title<span className="text-danger">*</span></label>
                                            <select ref="title" required className="form-control" defaultValue={this.props.fieldValues.title}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Mr">Mr</option>
                                                <option value="Miss">Miss</option>
                                                <option value="Mrs">Mrs</option>
                                                <option value="Chief">Chief</option>
                                                <option value="Dr.">Dr.</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Gender<span className="text-danger">*</span></label>
                                            <select ref="gender" required className="form-control" defaultValue={this.props.fieldValues.gender}>
                                                <option value="" hidden>Select...</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Email Address<span className="text-danger">*</span></label>
                                            <Form.Control type="email" className="form-control" ref="email" placeholder="Email Address" defaultValue={this.props.fieldValues.email} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Surname<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="surname" placeholder="Surname" defaultValue={this.props.fieldValues.surname} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>First Name<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="first_name" placeholder="First Name" defaultValue={this.props.fieldValues.first_name} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Other Name</label>
                                            <Form.Control type="text" className="form-control" ref="other_name" placeholder="Other Name" defaultValue={this.props.fieldValues.other_name} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Date of Birth<span className="text-danger">*</span></label>
                                            <Form.Control type="date" className="form-control" ref="dob" placeholder="Date of Birth" defaultValue={this.props.fieldValues.dob} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Residential Address<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="res_add" placeholder="Residential Address" defaultValue={this.props.fieldValues.res_add} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Means of Identification<span className="text-danger">*</span></label>
                                            <select ref="id_means" required className="form-control" defaultValue={this.props.fieldValues.id_means}>
                                                <option value="" hidden>Select...</option>
                                                <option value="International Passport">International Passport</option>
                                                <option value="Driver's Licence">Driver's Licence</option>
                                                <option value="National ID Card">National ID Card</option>
                                                <option value="Permanent Voters Card">Permanent Voters Card</option>
                                                <option value="Utility Bill">Utility Bill</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Telephone Number<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control uint" ref="phone" placeholder="Telephone Number" defaultValue={this.props.fieldValues.phone} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Bank Verification No<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control uint" ref="bvn" placeholder="Bank Verification No" defaultValue={this.props.fieldValues.bvn} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label htmlFor="attachments"><i className="fa fa-paperclip"></i> Signature<span className="text-danger">*</span></label>
                                            <Form.Control onChange={this.onChangeSignature} type="file" className="form-control" ref="attachments" accept=".jpeg,.jpg,.gif,.png" required />
                                        </Form.Group>
                                    </div>
                                    <button onClick={this.props.previousStep} type="button" className="btn btn-primary mr-2">Previous</button>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DirectorData1;